// extracted by mini-css-extract-plugin
export default {"pauseSpinner":"DgihApvXa2QqeTT0UPdL","pulse":"bXmFGY7R13RLlGZU3PJZ","spinner":"s_zZmYJILdWneNB0_zkr","spin":"cCA_hfXN8VRPOYW_6nPw"};